import React from 'react'
import styled from 'styled-components'
import robot from '../assets/robot.gif'
const Welcome = ({currentUser}) => {
  return (
    <Container>
        <img src={robot} alt="Robot" />
        <h1>Welcome,<span>{currentUser.username}</span> !</h1>
        <h3>Please Select a chat to start messaging.</h3>
    </Container>
  )
}

const Container = styled.div`
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;
color:white;
img{
    height:20rem;
}
h1{
  text-align:center;
    span{
        color:#4e00ff;
    }
}
h3{
  text-align:center;
}

@media screen and (max-width: 460px) {
  img{
    height:12rem;
  }

  h1{
    font-size:1rem;
  }
  h3{
    font-size:.8rem;
  }
}
`

export default Welcome